<template>
  <div
    :class="{
      'group bg-bgr-secondary hover:bg-bgr-secondary rounded-xl px-4 py-3': framed,
    }"
  >
    <label :class="['relative flex gap-3', { 'cursor-pointer': !readonly }]" :for="id">
      <input
        :id="id"
        v-model="inputValue"
        :class="[
          'peer relative aspect-square size-5 shrink-0 cursor-pointer appearance-none rounded-full border transition-all',
          'bg-radio-bgr-default hover:bg-radio-bgr-hover border-radio-bdr-default hover:border-radio-bdr-hover',
          'disabled:border-radio-bdr-disabled! disabled:bg-radio-bgr-disabled! disabled:hover:border-radio-bdr-disabled! disabled:hover:bg-radio-bgr-disabled! disabled:cursor-default',
          {
            'checked:border-radio-bgr-active checked:bg-radio-bgr-active checked:hover:border-radio-bgr-active-hover checked:hover:bg-radio-bgr-active-hover':
              inputValue,
            'bg-radio-bgr-critical! hover:bg-radio-bgr-critical-hover! border-radio-bdr-critical! hover:border-radio-bdr-critical-hover!':
              error,
          },
        ]"
        type="radio"
        :disabled="readonly"
        :indeterminate="indeterminate"
      />
      <div
        v-show="inputValue"
        :class="[
          'absolute inset-1.25 size-2.5 rounded-full transition duration-200',
          error ? 'bg-radio-fgr-critical' : 'bg-radio-fgr-active',
        ]"
      />
      <div v-if="slots.default" class="text-body-default">
        <slot />
      </div>
    </label>
  </div>
</template>

<script setup lang="ts">
  const id = `radio-${useId()}`;
  const slots = defineSlots();

  const props = withDefaults(
    defineProps<{
      readonly?: boolean;
      indeterminate?: boolean;
      name?: string;
      error?: string;
      selected?: boolean;
      framed?: boolean;
    }>(),
    {
      readonly: false,
      indeterminate: false,
      name: "",
      error: "",
      selected: false,
      framed: false,
    }
  );

  const _modelValue = defineModel<string>();
  const { value: inputValue } = useField(() => props.name, undefined, {
    type: "radio",
    checkedValue: true,
    uncheckedValue: false,
    syncVModel: props.name ? false : true,
    controlled: !!props.name,
  });

  watch(
    () => props.selected,
    (value) => {
      inputValue.value = value;
    },
    { immediate: true }
  );
</script>
